var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdobeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21.333,
    viewBox: "0 0 16 21.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M7.579,10.671A4.02,4.02,0,0,1,7.5,8.717C7.846,8.717,7.813,10.254,7.579,10.671Zm-.071,1.967A19.226,19.226,0,0,1,6.325,15.25a15.343,15.343,0,0,1,2.621-.912A5.4,5.4,0,0,1,7.508,12.637Zm-3.921,5.2c0,.033.55-.225,1.454-1.675A5.759,5.759,0,0,0,3.588,17.838ZM10.333,6.667H16V20.333a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H9.333V5.667A1,1,0,0,0,10.333,6.667ZM10,13.825a4.182,4.182,0,0,1-1.779-2.242,5.989,5.989,0,0,0,.258-2.675,1.044,1.044,0,0,0-1.992-.283,6.928,6.928,0,0,0,.337,3.208,39.126,39.126,0,0,1-1.7,3.575s0,0-.008,0c-1.129.579-3.067,1.854-2.271,2.833a1.3,1.3,0,0,0,.9.417c.746,0,1.488-.75,2.546-2.575a23.75,23.75,0,0,1,3.292-.967,6.315,6.315,0,0,0,2.667.813,1.079,1.079,0,0,0,.821-1.808c-.579-.567-2.262-.4-3.067-.3Zm5.708-9.45L11.625.292A1,1,0,0,0,10.917,0h-.25V5.333H16V5.079A1,1,0,0,0,15.708,4.375ZM12.621,15.012c.171-.112-.1-.5-1.783-.375C12.383,15.3,12.621,15.012,12.621,15.012Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeIcon);
export default __webpack_public_path__ + "static/media/adobeIcon.1305794f.svg";
export { ForwardRef as ReactComponent };